export function extractApiError(err: unknown, fallback: string): string {
  const e = err as { response?: { data?: { error?: { message?: string; details?: string[] } } } }
  const apiErr = e.response?.data?.error
  if (!apiErr) return fallback
  if (apiErr.details && apiErr.details.length > 0) return apiErr.details.join(', ')
  return apiErr.message ?? fallback
}

/**
 * Extracts structured validation errors from a 422 response.
 * Expects backend details to be in "field_name: error message" format.
 */
export function extractValidationErrors(err: unknown): Record<string, string> {
  const e = err as { response?: { data?: { error?: { code?: string; details?: string[] } } } }
  const apiErr = e.response?.data?.error
  const errors: Record<string, string> = {}

  if (apiErr?.code === 'VALIDATION_ERROR' && apiErr.details) {
    apiErr.details.forEach(detail => {
      const parts = detail.split(':')
      if (parts.length >= 2) {
        const field = parts[0].trim()
        const message = parts.slice(1).join(':').trim()
        errors[field] = message
      } else {
        errors['form'] = detail
      }
    })
  }
  return errors
}
